
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './CallUsNow.css';

class BannerOne extends Component {
  render() {
    return (
      <div
        className='cm-banner overlay bg-cover'
        style={{ backgroundImage: 'url(assets/images/bg-banner.jpg)' }}
      >
        <div className='container h-100'>
          <div className='row h-100 align-items-center'>
            <div className='col-xl-6 col-lg-7 mx-auto text-center'>
              <div className='block text-white'>
                {/* Trust Badge */}
                <div className='trust-badge mb-20'>
                  <span
                    style={{
                      display: 'inline-block',
                      background: 'rgba(255, 255, 255, 0.15)',
                      backdropFilter: 'blur(10px)',
                      padding: '8px 20px',
                      borderRadius: '50px',
                      fontSize: '0.9rem',
                      fontWeight: '600',
                      letterSpacing: '0.5px'
                    }}
                  >
                    <span className="fas fa-star text-warning mr-2" />
                    Trusted Since 2006 • 19+ Years Experience
                  </span>
                </div>

                <h3 className="mb-15">Mobile & Computer Repair Service</h3>
                <h1
                  className="display-3"
                  style={{
                    color: '#ffaa19',
                    textShadow: `
                      -1px -1px 0 #007bff,
                      1px -1px 0 #007bff,
                      -1px 1px 0 #007bff,
                      1px 1px 0 #007bff
                    `,
                  }}
                >
                  Cell Station
                </h1>

                <p className='lead mt-25 mb-20'>
                  Fast, reliable repairs for iPhone, Samsung, iPad, MacBook & more.
                </p>

                {/* Value Props */}
                <div className='value-props mb-30' style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '20px',
                  flexWrap: 'wrap',
                  fontSize: '0.9rem'
                }}>
                  <span><i className="fas fa-check-circle text-success mr-2" />Same-Day Service</span>
                  <span><i className="fas fa-check-circle text-success mr-2" />Quality Parts</span>
                  <span><i className="fas fa-check-circle text-success mr-2" />Warranty Included</span>
                </div>

                {/* Buttons container */}
                <div className='buttons-container'>
                  <a
                    className="btn btn-primary initiate-scripts btn-pulse"
                    href="tel:+12159393933"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '12px',
                      padding: '12px 24px',
                      fontSize: '1rem',
                      justifyContent: 'center'
                    }}
                  >
                    <i
                      className="fas fa-phone-alt"
                      style={{ lineHeight: 1, verticalAlign: 'middle' }}
                    />
                    Call Us Now
                  </a>

                  <Link
                    className='btn btn-light initiate-scripts'
                    to={'/store-location'}
                    style={{ padding: '12px 24px', fontSize: '1rem' }}
                  >
                    <i className="fas fa-map-marker-alt mr-2" />
                    Find Us
                  </Link>

                  <Link
                    className='btn btn-primary initiate-scripts'
                    to={'/contact-us'}
                    style={{ padding: '12px 24px', fontSize: '1rem' }}
                  >
                    Get a Quote
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BannerOne;

